export default {
  account: () => import("/home/jcwl/project/roncoo-education-web/layouts/account.vue").then(m => m.default || m),
  activity: () => import("/home/jcwl/project/roncoo-education-web/layouts/activity.vue").then(m => m.default || m),
  buy: () => import("/home/jcwl/project/roncoo-education-web/layouts/buy.vue").then(m => m.default || m),
  course: () => import("/home/jcwl/project/roncoo-education-web/layouts/course.vue").then(m => m.default || m),
  default: () => import("/home/jcwl/project/roncoo-education-web/layouts/default.vue").then(m => m.default || m)
}